export interface MainTableData {
    _id: string;
    date: string;
    openingBalance: number;
    totalTransactionValue: number;
    closingBalance: number;
}
export interface DetailedTableData {
    createdAt: string;
    userId: { name: string };
    user: any;
    narration: string;
    openingBalance: number;
    transactionValue: number;
    closingBalance: number;
}
export type ChargeRateType = {
    _id: string;
    organization: string;
    currency: string;
    awbRate: number;
    containerRate: number;
    idpRate: number;
    __v: number;
};

export type OrganizationResponseType = {
    _id: string;
    organizationName: string;
    pan: string;
    gst: string;
    officeCountry: string;
    officeCity: string;
    address: string;
    mobileNumber: string;
    adminEmailId: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
    __v: number;
    numberOfLicenses: number;
    module: string[];
    chargeRate?: ChargeRateType;
};

export type ChargeRateMappingType = {
    organizationName: string;
    currency: string;
    awbRate: string;
    idpRate: string;
    containerRate: string;
};

export type ReteRelatedTypeInput = {
    currency: string;
    awbRate: string;
    containerRate: string;
    idpRate: string;
}
export type isChangedTheRate = {
    awbRate: boolean;
    containerRate: boolean;
    idpRate: boolean;
}
export type CreditInputType = {
    creditValue: string;
}
export type CurrencyOptionType = {
  label: string;
  value: string;
};

export type InputFieldError={
    creditError:string,
    awbRateError:string,
    containerRateError:string,
    currencyError:string,
    idpRateError:string
}
export function extractChargeRateInfo(data: OrganizationResponseType): ChargeRateMappingType {
    
    let awbRate=(data?.chargeRate?.awbRate)??"";
   let containerRate= data?.chargeRate?.containerRate??""
   let idpRate= data?.chargeRate?.idpRate??""
    let mappedData= {
        organizationName: data.organizationName,
        currency: data.chargeRate?.currency || "",
        awbRate: awbRate.toString(),
        containerRate: containerRate.toString(),
        idpRate: idpRate.toString(),
    };
 
    return mappedData
}

export type UserListType={
    value:string,
    label:string
}